/* ============================================================
   ALPHA VITAL — section-header.js
   Sticky behaviour, overlay→solid, mobile menu, announcement bar
   ============================================================ */
(function () {
  'use strict';

  const header        = document.querySelector('.site-header');
  const mobileMenu    = document.querySelector('.mobile-menu');
  const hamburger     = document.querySelector('.site-header__hamburger');
  const mobileClose   = document.querySelector('.mobile-menu__close');
  const overlay       = document.querySelector('.mobile-menu__overlay');
  const annoBar       = document.querySelector('.announcement-bar');
  const annoClose     = document.querySelector('.announcement-bar__close');

  if (!header) return;

  const isOverlay     = header.classList.contains('site-header--overlay');
  let   headerHeight  = header.offsetHeight;
  let   annoHeight    = annoBar ? annoBar.offsetHeight : 0;
  let   isCompact     = null;     // letzter Compact-Zustand (verhindert redundante DOM-Arbeit)
  let   ticking       = false;    // rAF-Drossel
  let   offsetTimer   = null;

  /* --header-offset misst die ECHTE Header-Höhe für Sticky-Elemente (z.B. Produkt-Tabs).
     PERFORMANCE-KRITISCH: NICHT bei jedem Scroll messen — getBoundingClientRect erzwingt
     einen Reflow und das Setzen der CSS-Variable löst Style-Recalc ALLER Offset-Nutzer aus
     → genau das ruckelte auf Mobile. Daher nur bei echter Höhenänderung (Compact-Toggle /
     Resize / Load) und erst NACH der 0,3s-Transition (sonst Zwischenwerte → Header „zuckt"). */
  function updateHeaderOffset() {
    document.documentElement.style.setProperty('--header-offset', header.getBoundingClientRect().height + 'px');
  }
  function scheduleHeaderOffset() {
    clearTimeout(offsetTimer);
    offsetTimer = setTimeout(updateHeaderOffset, 320);
  }

  /* ── Scroll-Handler: rAF-gedrosselt, pro Frame nur billige Klassen-No-Ops ── */
  function applyHeaderState() {
    ticking = false;
    const current = window.scrollY;
    const threshold = annoHeight + 20;

    header.classList.remove('site-header--hidden');   // Header bleibt immer sichtbar

    let compact;
    if (!isOverlay) {
      /* Unterseiten: immer solid */
      header.classList.add('site-header--solid');
      header.classList.remove('site-header--transparent');
      compact = current > headerHeight;
    } else if (current <= threshold) {
      /* Startseite oben: transparent */
      header.classList.add('site-header--transparent');
      header.classList.remove('site-header--solid');
      compact = false;
    } else {
      /* Startseite gescrollt: solid */
      header.classList.remove('site-header--transparent');
      header.classList.add('site-header--solid');
      compact = current > headerHeight;
    }

    /* Compact-Klasse + Offset NUR bei echtem Zustandswechsel anfassen */
    if (compact !== isCompact) {
      isCompact = compact;
      header.classList.toggle('site-header--compact', compact);
      scheduleHeaderOffset();   // Höhe ändert sich → Offset nach der Transition neu messen
    }
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(applyHeaderState); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  applyHeaderState();   // initialer Zustand

  /* Header-Höhe (für Compact-Schwelle + Offset) bei Resize/Load neu bestimmen */
  function updateHeaderVar() {
    headerHeight = header.offsetHeight + (annoBar ? annoBar.offsetHeight : 0);
    updateHeaderOffset();
  }
  updateHeaderVar();
  window.addEventListener('resize', updateHeaderVar);

  /* ── Mobile menu ── */
  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    hamburger?.setAttribute('aria-expanded', 'true');
    setTimeout(function () { (mobileClose || mobileMenu.querySelector('a, button'))?.focus(); }, 60);
    if (window.avTrapFocus) window.avTrapFocus(mobileMenu);
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    document.body.style.overflow = '';
    hamburger?.setAttribute('aria-expanded', 'false');
    if (window.avReleaseFocus) window.avReleaseFocus();
    try { hamburger?.focus(); } catch (e) {}
  }

  hamburger?.addEventListener('click', openMenu);
  mobileClose?.addEventListener('click', closeMenu);
  overlay?.addEventListener('click', closeMenu);

  // Nur schließen, wenn das Menü offen ist — sonst zieht jedes Escape (z. B. im
  // Cookie-Dialog) den Fokus auf den Hamburger und setzt body.overflow zurück.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) closeMenu();
  });

  /* Mobile sub-nav toggles */
  document.querySelectorAll('.mobile-menu__nav-link[data-has-children]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const sub = link.nextElementSibling;
      if (sub && sub.classList.contains('mobile-menu__subnav')) {
        sub.classList.toggle('is-open');
        link.querySelector('.site-header__chevron')?.classList.toggle('is-rotated');
      }
    });
  });

  /* ── Katalog-Vorschau: Hover über Kategorie (Desktop) zeigt deren Produkte ── */
  const flyoutPanel = document.querySelector('[data-flyout-panel]');
  const catLinks    = document.querySelectorAll('[data-cat-preview]');
  if (flyoutPanel && catLinks.length) {
    const canHover = window.matchMedia('(hover: hover)').matches;
    const previewGroups = flyoutPanel.querySelectorAll('.catalog-flyout__preview[data-preview-group]');
    const prevBlocks    = flyoutPanel.querySelectorAll('.cf-prev[data-prev]');
    const subLinks      = flyoutPanel.querySelectorAll('.catalog-flyout__sublink[data-sub]');
    let closeTimer = null;

    const showPreview = (handle) => {
      prevBlocks.forEach(p => p.classList.toggle('is-active', p.dataset.prev === handle));
      subLinks.forEach(s => s.classList.toggle('is-active', s.dataset.sub === handle));
    };
    const showGroup = (idx) => {
      flyoutPanel.classList.remove('is-direct');
      catLinks.forEach(l => l.classList.toggle('is-active', l.dataset.catPreview === idx));
      let first = null;
      previewGroups.forEach(g => {
        const on = g.dataset.previewGroup === idx;
        g.classList.toggle('is-active', on);
        if (on && !first) first = g.querySelector('.catalog-flyout__sublink[data-sub]');
      });
      if (first) showPreview(first.dataset.sub);
    };
    const openFlyout   = () => {
      clearTimeout(closeTimer);
      flyoutPanel.classList.add('is-open');
      flyoutPanel.style.opacity = '1';
      flyoutPanel.style.visibility = 'visible';
      flyoutPanel.style.transform = 'translateX(0)';
      flyoutPanel.style.pointerEvents = 'auto';
    };
    const closeFlyout  = () => {
      flyoutPanel.classList.remove('is-open', 'is-direct');
      flyoutPanel.style.opacity = '';
      flyoutPanel.style.visibility = '';
      flyoutPanel.style.transform = '';
      flyoutPanel.style.pointerEvents = '';
    };
    const closeDelayed = () => { closeTimer = setTimeout(closeFlyout, 180); };

    catLinks.forEach(link => {
      // Tap/Klick (Touch + Desktop): Unterkategorien der Kategorie zeigen/verstecken
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const idx = link.dataset.catPreview;
        const open = link.classList.contains('is-active') && flyoutPanel.classList.contains('is-open');
        if (open) { closeFlyout(); link.setAttribute('aria-expanded', 'false'); }
        else { showGroup(idx); openFlyout(); link.setAttribute('aria-expanded', 'true'); }
      });
      if (canHover) {
        link.addEventListener('mouseenter', () => { showGroup(link.dataset.catPreview); openFlyout(); link.setAttribute('aria-expanded', 'true'); });
        link.addEventListener('focus',      () => { showGroup(link.dataset.catPreview); openFlyout(); });
        link.addEventListener('mouseleave', closeDelayed);
      }
    });
    // Direkte Kollektions-Links (Alle Produkte, Refills, Frauen, Männer): Hover zeigt nur die Produktvorschau
    const directLinks = document.querySelectorAll('[data-direct-preview]');
    if (canHover) {
      directLinks.forEach(link => {
        link.addEventListener('mouseenter', () => {
          flyoutPanel.classList.add('is-direct');
          catLinks.forEach(l => { l.classList.remove('is-active'); l.setAttribute('aria-expanded', 'false'); });
          showPreview(link.dataset.directPreview);
          openFlyout();
        });
        link.addEventListener('mouseleave', closeDelayed);
      });
      subLinks.forEach(s => s.addEventListener('mouseenter', () => showPreview(s.dataset.sub)));
      flyoutPanel.addEventListener('mouseenter', openFlyout);
      flyoutPanel.addEventListener('mouseleave', closeDelayed);
    }

    // Beim Schließen des Drawers auch die Vorschau schließen
    if (mobileMenu) {
      const mo = new MutationObserver(() => {
        if (!mobileMenu.classList.contains('is-open')) closeFlyout();
      });
      mo.observe(mobileMenu, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ── Announcement bar close ── */
  annoClose?.addEventListener('click', () => {
    if (annoBar) {
      annoBar.style.maxHeight = annoBar.offsetHeight + 'px';
      requestAnimationFrame(() => {
        annoBar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
        annoBar.style.maxHeight = '0';
        annoBar.style.opacity = '0';
        annoBar.style.overflow = 'hidden';
        setTimeout(() => { annoBar.remove(); updateHeaderVar(); }, 320);
      });
    }
  });

  /* Announcement bar rotation */
  const annoItems = document.querySelectorAll('.announcement-bar__item');
  if (annoItems.length > 1) {
    let idx = 0;
    annoItems.forEach((el, i) => { if (i > 0) el.hidden = true; });
    setInterval(() => {
      annoItems[idx].hidden = true;
      idx = (idx + 1) % annoItems.length;
      annoItems[idx].hidden = false;
    }, 4000);
  }

  /* Rotierende Such-Vorschläge — Placeholder aller Suchfelder wechselt alle 5s
     (Header-Inline, Such-Overlay/Mobile, Suchergebnis-Seite) mit sanftem Fade. */
  (function rotateSearchPlaceholders() {
    var suggestions = [
      'Magnesium', 'Vitamin D3', 'Vitamin C', 'Vitamin B12',
      'Zink', 'Omega 3', 'Eisen', 'Melatonin', 'Selen', 'Immunsystem'
    ];
    var inputs = document.querySelectorAll('input[type="search"]');
    if (!inputs.length) return;

    var style = document.createElement('style');
    style.textContent =
      'input[type="search"]::placeholder{transition:opacity .35s ease;opacity:1}' +
      'input[type="search"].av-ph-fade::placeholder{opacity:0}';
    document.head.appendChild(style);

    var i = -1;
    setInterval(function () {
      i = (i + 1) % suggestions.length;
      var text = 'Suche nach „' + suggestions[i] + '“ …';
      inputs.forEach(function (el) {
        if (document.activeElement === el) return; /* aktiv getipptes Feld nicht stören */
        el.classList.add('av-ph-fade');
        setTimeout(function () {
          el.setAttribute('placeholder', text);
          el.classList.remove('av-ph-fade');
        }, 350);
      });
    }, 5000);
  })();
})();
